/* Product-page Amazon Attribution button. Links are generated by Amazon Ads and
   selected using the exact Shopify variant ID from the product form. */
(() => {
  if (customElements.get('amazon-attribution-buy')) return;

  const linkFiles = new Map();

  function attributionUrl(value) {
    if (typeof value !== 'string') return null;
    try {
      const url = new URL(value);
      if (
        url.protocol !== 'https:' ||
        url.hostname !== 'www.amazon.com' ||
        !/^\/dp\/[A-Z0-9]{10}$/.test(url.pathname) ||
        !url.searchParams.get('maas')
      ) return null;
      return url.href;
    } catch {
      return null;
    }
  }

  class AmazonAttributionBuy extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.productForm = this.closest('product-form');
      this.link = this.querySelector('[data-amazon-attribution-link]');
      this.variantLabel = this.querySelector('[data-amazon-attribution-variant]');
      this.onSelectionChange = this.sync.bind(this);
      this.productInfo?.addEventListener('change', this.onSelectionChange);
      this.loadLinks();
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onSelectionChange);
    }

    async loadLinks() {
      const source = this.dataset.linksUrl;
      if (!source || !this.productInfo || !this.productForm || !this.link) return;
      if (!linkFiles.has(source)) {
        linkFiles.set(source, fetch(source, { credentials: 'same-origin' }).then((response) => {
          if (!response.ok) throw new Error(`Amazon link file HTTP ${response.status}`);
          return response.json();
        }));
      }
      try {
        const products = await linkFiles.get(source);
        this.links = products?.[this.dataset.productId] || {};
        this.sync();
      } catch {
        linkFiles.delete(source);
        this.hidden = true;
      }
    }

    selectedVariant() {
      const input = this.productForm?.querySelector('form input[name="id"]');
      const variantId = input?.value;
      if (!variantId) return null;

      const picker = this.productInfo?.querySelector('variant-selects');
      if (!picker) return { id: variantId, label: '' };

      const groups = [...picker.querySelectorAll('fieldset, .product-form__input--dropdown')];
      const values = groups.map((group) => {
        const selected = group.querySelector('input:checked, select');
        return selected?.value || '';
      });
      if (values.length === 0 || values.some((value) => !value)) return null;

      try {
        const selected = JSON.parse(picker.querySelector('[data-selected-variant]')?.textContent || 'null');
        if (
          String(selected?.id) !== variantId ||
          !Array.isArray(selected?.options) ||
          selected.options.length !== values.length ||
          !values.every((value, index) => selected.options[index] === value)
        ) return null;
      } catch {
        return null;
      }
      return { id: variantId, label: values.join(' / ') };
    }

    sync() {
      this.hidden = true;
      this.link?.removeAttribute('href');
      if (!this.links || !this.isConnected) return;
      const selected = this.selectedVariant();
      const url = selected && attributionUrl(this.links[selected.id]);
      if (!url) return;
      this.link.href = url;
      if (this.variantLabel) this.variantLabel.textContent = selected.label ? ` · ${selected.label}` : '';
      this.hidden = false;
    }
  }

  customElements.define('amazon-attribution-buy', AmazonAttributionBuy);
})();
